// FILE: src/App.js
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute  from "./components/main/PrivateRoute";
import RequireAdmin  from "./components/main/RequireAdmin";
import ErrorBoundary from "./components/main/ErrorBoundary";
import Layout from "./components/layout/Layout";
import NotFound404 from "./pages/errors/NotFound404";
import "./App.css";

const Login = React.lazy(() => import("./pages/login/Login"));
const Feed = React.lazy(() => import("./pages/feed/Feed"));
const Profile = React.lazy(() => import("./pages/profile").then((m) => ({ default: m.Profile })));
const ProfileLayout = React.lazy(() => import("./pages/profile").then((m) => ({ default: m.ProfileLayout })));
const Settings = React.lazy(() => import("./pages/profile").then((m) => ({ default: m.Settings })));
const BugReport = React.lazy(() => import("./pages/profile").then((m) => ({ default: m.BugReport })));
const TicketThread = React.lazy(() => import("./pages/profile").then((m) => ({ default: m.TicketThread })));
const Live = React.lazy(() => import("./pages/platform/Live/Live"));
const Admin = React.lazy(() => import("./pages/admin/Admin"));
const Oauth = React.lazy(() => import("./pages/platform/Oauth/Oauth"));
const Channels = React.lazy(() => import("./pages/platform/Channels/Channels"));
const Follow = React.lazy(() => import("./pages/platform/Follow/Follow"));
const Stats = React.lazy(() => import("./pages/platform/Stats/Stats"));
const Channel = React.lazy(() => import("./pages/platform/Channel/Channel"));
const OauthEdit = React.lazy(() => import("./pages/platform/OauthEdit/OauthEdit"));
const ChattingMenu = React.lazy(() => import("./pages/chatting/menu/ChattingMenu"));
const Chatter = React.lazy(() => import("./pages/chatting/chatter/Chatter"));
const Streamer = React.lazy(() => import("./pages/chatting/streamer/Streamer"));

const RouteFallback = () => (
  <div className="min-h-screen bg-slate-950" />
);

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {/* публично доступные */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />

            {/* защищённая зона */}
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                {/* --- АДМИНКА: только для админов --- */}
                <Route element={<RequireAdmin />}>
                  <Route path="admin/*" element={<Admin />} />
                </Route>

                {/* просмотр чужих профилей */}
                <Route path="user/:username" element={<Profile />} />

                {/* основные */}
                <Route path="feed" element={<Feed />} />
                <Route path="chatting/menu" element={<ChattingMenu />} />
                <Route path="chatting/chatter" element={<Chatter />} />
                <Route path="chatting/streamer" element={<Streamer />} />

                {/* личный профиль */}
                <Route path="profile/*" element={<ProfileLayout />}>
                  <Route index element={<Profile />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="bugs" element={<BugReport />}>
                    <Route path=":id" element={<TicketThread />} />
                  </Route>
                </Route>

                {/* платформа */}
                <Route path=":platform" element={<NotFound404 />} />
                <Route path=":platform/*">
                  <Route path="live" element={<Live />} />
                  <Route path="oauth" element={<Oauth />} />
                  <Route path="channels" element={<Channels />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="follow" element={<Follow />} />
                  <Route path="stats" element={<Stats />} />
                  <Route path="channel/:channelName" element={<Channel />} />
                  <Route path="oauth/edit/:groupId" element={<OauthEdit />} />
                  <Route path="*" element={<NotFound404 />} />
                </Route>

                {/* защищённый 404 */}
                <Route path="*" element={<NotFound404 />} />
              </Route>
            </Route>

            {/* глобальный 404 */}
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
